import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/573054520211?text=Hola%20vengo%20desde%20la%20web%20y%20quiero%20reservar%20una%20cita';
const MAPS_LINK = 'https://www.google.com/maps/search/?api=1&query=6.1517,-75.6167';
export function LocationSection() {
  return <section id="ubicacion" className="py-12 md:py-24 bg-brand-black" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="text-center mb-8 md:mb-16" data-id="element-78">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-playfair text-white mb-4 relative inline-block" data-id="element-79">
            Encuéntranos
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-brand-gold rounded-full" data-id="element-80"></div>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-81">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-82">
            <div className="bg-brand-card p-5 md:p-8 rounded-sm border border-brand-dark" data-id="element-83">
              <div className="flex items-start gap-4 mb-6" data-id="element-84">
                <MapPin className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-85" />
                <div data-id="element-86">
                  <h3 className="text-xl font-playfair text-white mb-2" data-id="element-87">
                    Dirección
                  </h3>
                  <p className="text-brand-gray text-lg" data-id="element-88">
                    Cl. 75 Sur #45-82 LOCAL 0201
                    <br data-id="element-89" />
                    Sabaneta, Antioquia
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-8" data-id="element-90">
                <Clock className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-91" />
                <div data-id="element-92">
                  <h3 className="text-xl font-playfair text-white mb-2" data-id="element-93">
                    Horario
                  </h3>
                  <p className="text-brand-gray" data-id="element-94">
                    <span className="block mb-1" data-id="element-95">
                      Lunes a Sábado: 9:00 AM - 8:00 PM
                    </span>
                    <span className="block" data-id="element-96">Domingo: 10:00 AM - 5:00 PM</span>
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4 border-t border-brand-dark" data-id="element-97">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex-1 btn-gold px-6 py-3 text-center flex items-center justify-center gap-2" data-id="element-98">
                  <Phone className="w-5 h-5" data-id="element-99" />
                  Escribir por WhatsApp
                </a>
                <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" className="flex-1 btn-outline-gold px-6 py-3 text-center flex items-center justify-center gap-2" data-id="element-100">
                  <MapPin className="w-5 h-5" data-id="element-101" />
                  Cómo llegar
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-[250px] md:h-[400px] lg:h-[500px] rounded-sm overflow-hidden border border-brand-gold/20 relative" data-id="element-102">
            {/* Using an iframe for Google Maps centered on Sabaneta coordinates */}
            <iframe src="https://maps.google.com/maps?q=6.1517,-75.6167&z=15&output=embed" width="100%" height="100%" style={{
            border: 0,
            filter: 'invert(90%) hue-rotate(180deg) grayscale(80%) contrast(120%)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mapa de Sabaneta" className="absolute inset-0" data-id="element-103"></iframe>

            {/* Overlay to ensure map styling matches dark theme better */}
            <div className="absolute inset-0 pointer-events-none bg-brand-black/20 mix-blend-multiply" data-id="element-104"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}